var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-skeleton-loading"},[_c('v-row',{staticClass:"mt-2 mb-2"},_vm._l((6),function(n){return _c('v-col',{key:n,attrs:{"cols":"12","sm":"12","md":"6","lg":"4","align":"center"}},[_c('v-skeleton-loader',{attrs:{"type":"card"}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }